import { Input } from '../ui/input';
import { cn } from '../../lib/utils';

/**
 * Input with a datalist dropdown showing entity options from the database.
 * Supports free-text entry AND selection from a suggestion list.
 * Uses native HTML datalist which works reliably inside dialogs/modals.
 *
 * Props:
 *   value       - current value (string)
 *   onChange     - (value: string) => void
 *   options      - array of { label, value, email?, department?, company? }
 *   placeholder  - input placeholder
 *   listId       - unique ID for the datalist (required for multiple instances)
 *   className    - extra classNames for the wrapper
 *   inputProps   - extra props spread onto the Input
 *   onSelect     - optional callback when user selects from list: (option) => void
 */
export function EntitySelect({ value, onChange, options = [], placeholder, listId, className, inputProps = {}, onSelect }) {
  const id = listId || `entity-list-${Math.random().toString(36).slice(2, 8)}`;

  const handleChange = (e) => {
    const v = e.target.value;
    onChange(v);
    if (onSelect) {
      const match = options.find(o => o.value === v || o.label === v);
      if (match) onSelect(match);
    }
  };

  return (
    <div className={cn("relative", className)}>
      <Input
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        autoComplete="off"
        list={id}
        {...inputProps}
      />
      <datalist id={id}>
        {options.map((opt, i) => (
          <option key={opt.id || i} value={opt.value}>
            {opt.email ? `${opt.label} — ${opt.email}` : opt.label}
          </option>
        ))}
      </datalist>
    </div>
  );
}
